module.exports = "<main class=\"container-fluid h-100\">\n    <router-outlet></router-outlet>\n</main>"